export default [
  { value: "none", label: "Selecionar" },
  { value: "0", label: "0 - Preço tabelado ou máximo sugerido" },
  { value: "1", label: "1 - Lista Negativa (valor)" },
  { value: "2", label: "2 - Lista Positiva (valor)" },
  { value: "3", label: "3 - Lista Neutra (valor)" },
  { value: "4", label: "4 - Margem Valor Agregado (%)" },
  { value: "5", label: "5 - Pauta (valor)" }
];



// WEBPACK FOOTER //
// ./src/core/enum/modbcst-values.enum.js